export class ReflectorRequestError extends Error {
	public constructor() {
		super('The request is invalid and could not be processed');
	}
}
